/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const SdfAccordion = /*@__PURE__*/ createReactComponent('sdf-accordion');
export const SdfActionArea = /*@__PURE__*/ createReactComponent('sdf-action-area');
export const SdfActionMenu = /*@__PURE__*/ createReactComponent('sdf-action-menu');
export const SdfAlert = /*@__PURE__*/ createReactComponent('sdf-alert');
export const SdfAlertBanner = /*@__PURE__*/ createReactComponent('sdf-alert-banner');
export const SdfAlertIcon = /*@__PURE__*/ createReactComponent('sdf-alert-icon');
export const SdfAlertInline = /*@__PURE__*/ createReactComponent('sdf-alert-inline');
export const SdfAlertToast = /*@__PURE__*/ createReactComponent('sdf-alert-toast');
export const SdfAppLoader = /*@__PURE__*/ createReactComponent('sdf-app-loader');
export const SdfAvatar = /*@__PURE__*/ createReactComponent('sdf-avatar');
export const SdfBadge = /*@__PURE__*/ createReactComponent('sdf-badge');
export const SdfBox = /*@__PURE__*/ createReactComponent('sdf-box');
export const SdfBoxStack = /*@__PURE__*/ createReactComponent('sdf-box-stack');
export const SdfBusyIndicator = /*@__PURE__*/ createReactComponent('sdf-busy-indicator');
export const SdfButton = /*@__PURE__*/ createReactComponent('sdf-button');
export const SdfButtonGroup = /*@__PURE__*/ createReactComponent('sdf-button-group');
export const SdfButtonLayout = /*@__PURE__*/ createReactComponent('sdf-button-layout');
export const SdfCalendar = /*@__PURE__*/ createReactComponent('sdf-calendar');
export const SdfCard = /*@__PURE__*/ createReactComponent('sdf-card');
export const SdfCardFooter = /*@__PURE__*/ createReactComponent('sdf-card-footer');
export const SdfCardHeader = /*@__PURE__*/ createReactComponent('sdf-card-header');
export const SdfCardHeaderAdvanced = /*@__PURE__*/ createReactComponent('sdf-card-header-advanced');
export const SdfCardHeaderCollapsible = /*@__PURE__*/ createReactComponent('sdf-card-header-collapsible');
export const SdfCarousel = /*@__PURE__*/ createReactComponent('sdf-carousel');
export const SdfCarouselItem = /*@__PURE__*/ createReactComponent('sdf-carousel-item');
export const SdfChart = /*@__PURE__*/ createReactComponent('sdf-chart');
export const SdfCheckbox = /*@__PURE__*/ createReactComponent('sdf-checkbox');
export const SdfCheckboxGroup = /*@__PURE__*/ createReactComponent('sdf-checkbox-group');
export const SdfCloseButton = /*@__PURE__*/ createReactComponent('sdf-close-button');
export const SdfColumnChart = /*@__PURE__*/ createReactComponent('sdf-column-chart');
export const SdfCurrencyInput = /*@__PURE__*/ createReactComponent('sdf-currency-input');
export const SdfDashboard = /*@__PURE__*/ createReactComponent('sdf-dashboard');
export const SdfDashboardCell = /*@__PURE__*/ createReactComponent('sdf-dashboard-cell');
export const SdfDataRing = /*@__PURE__*/ createReactComponent('sdf-data-ring');
export const SdfDatePicker = /*@__PURE__*/ createReactComponent('sdf-date-picker');
export const SdfDatePickerV2 = /*@__PURE__*/ createReactComponent('sdf-date-picker-v2');
export const SdfExpandableBox = /*@__PURE__*/ createReactComponent('sdf-expandable-box');
export const SdfFileItem = /*@__PURE__*/ createReactComponent('sdf-file-item');
export const SdfFileSelector = /*@__PURE__*/ createReactComponent('sdf-file-selector');
export const SdfFileUploader = /*@__PURE__*/ createReactComponent('sdf-file-uploader');
export const SdfFlagLayout = /*@__PURE__*/ createReactComponent('sdf-flag-layout');
export const SdfFloatingPane = /*@__PURE__*/ createReactComponent('sdf-floating-pane');
export const SdfFloatingPanePortal = /*@__PURE__*/ createReactComponent('sdf-floating-pane-portal');
export const SdfFocusPane = /*@__PURE__*/ createReactComponent('sdf-focus-pane');
export const SdfFormControlLayout = /*@__PURE__*/ createReactComponent('sdf-form-control-layout');
export const SdfGrid = /*@__PURE__*/ createReactComponent('sdf-grid');
export const SdfHelpText = /*@__PURE__*/ createReactComponent('sdf-help-text');
export const SdfHomePageLayout = /*@__PURE__*/ createReactComponent('sdf-home-page-layout');
export const SdfIcon = /*@__PURE__*/ createReactComponent('sdf-icon');
export const SdfIconButton = /*@__PURE__*/ createReactComponent('sdf-icon-button');
export const SdfIconLegacy = /*@__PURE__*/ createReactComponent('sdf-icon-legacy');
export const SdfIconStack = /*@__PURE__*/ createReactComponent('sdf-icon-stack');
export const SdfInlineModal = /*@__PURE__*/ createReactComponent('sdf-inline-modal');
export const SdfInput = /*@__PURE__*/ createReactComponent('sdf-input');
export const SdfLayoutJustifyEdge = /*@__PURE__*/ createReactComponent('sdf-layout-justify-edge');
export const SdfLayoutListItem = /*@__PURE__*/ createReactComponent('sdf-layout-list-item');
export const SdfLayoutRow = /*@__PURE__*/ createReactComponent('sdf-layout-row');
export const SdfLayoutThreeCol = /*@__PURE__*/ createReactComponent('sdf-layout-three-col');
export const SdfLayoutTwoCol = /*@__PURE__*/ createReactComponent('sdf-layout-two-col');
export const SdfLineChart = /*@__PURE__*/ createReactComponent('sdf-line-chart');
export const SdfLink = /*@__PURE__*/ createReactComponent('sdf-link');
export const SdfMenu = /*@__PURE__*/ createReactComponent('sdf-menu');
export const SdfMenuDivider = /*@__PURE__*/ createReactComponent('sdf-menu-divider');
export const SdfMenuItem = /*@__PURE__*/ createReactComponent('sdf-menu-item');
export const SdfMenuTitle = /*@__PURE__*/ createReactComponent('sdf-menu-title');
export const SdfMfeLoader = /*@__PURE__*/ createReactComponent('sdf-mfe-loader');
export const SdfMiniCard = /*@__PURE__*/ createReactComponent('sdf-mini-card');
export const SdfMultiSelect = /*@__PURE__*/ createReactComponent('sdf-multi-select');
export const SdfPageHeaderLayout = /*@__PURE__*/ createReactComponent('sdf-page-header-layout');
export const SdfPageLayout = /*@__PURE__*/ createReactComponent('sdf-page-layout');
export const SdfPagination = /*@__PURE__*/ createReactComponent('sdf-pagination');
export const SdfPhoneNumberInput = /*@__PURE__*/ createReactComponent('sdf-phone-number-input');
export const SdfPieChart = /*@__PURE__*/ createReactComponent('sdf-pie-chart');
export const SdfProgressBar = /*@__PURE__*/ createReactComponent('sdf-progress-bar');
export const SdfPromoBox = /*@__PURE__*/ createReactComponent('sdf-promo-box');
export const SdfQuickStat = /*@__PURE__*/ createReactComponent('sdf-quick-stat');
export const SdfRadioButton = /*@__PURE__*/ createReactComponent('sdf-radio-button');
export const SdfRadioGroup = /*@__PURE__*/ createReactComponent('sdf-radio-group');
export const SdfReadonlyField = /*@__PURE__*/ createReactComponent('sdf-readonly-field');
export const SdfScroller = /*@__PURE__*/ createReactComponent('sdf-scroller');
export const SdfSearch = /*@__PURE__*/ createReactComponent('sdf-search');
export const SdfSegmentFiller = /*@__PURE__*/ createReactComponent('sdf-segment-filler');
export const SdfSegmentedControl = /*@__PURE__*/ createReactComponent('sdf-segmented-control');
export const SdfSelect = /*@__PURE__*/ createReactComponent('sdf-select');
export const SdfSelectGroup = /*@__PURE__*/ createReactComponent('sdf-select-group');
export const SdfSelectItem = /*@__PURE__*/ createReactComponent('sdf-select-item');
export const SdfSelectItemList = /*@__PURE__*/ createReactComponent('sdf-select-item-list');
export const SdfSelectList = /*@__PURE__*/ createReactComponent('sdf-select-list');
export const SdfSelectOption = /*@__PURE__*/ createReactComponent('sdf-select-option');
export const SdfSelectSimple = /*@__PURE__*/ createReactComponent('sdf-select-simple');
export const SdfShimmer = /*@__PURE__*/ createReactComponent('sdf-shimmer');
export const SdfSkeleton = /*@__PURE__*/ createReactComponent('sdf-skeleton');
export const SdfSlider = /*@__PURE__*/ createReactComponent('sdf-slider');
export const SdfSpinner = /*@__PURE__*/ createReactComponent('sdf-spinner');
export const SdfSpotIllustration = /*@__PURE__*/ createReactComponent('sdf-spot-illustration');
export const SdfSuperTitle = /*@__PURE__*/ createReactComponent('sdf-super-title');
export const SdfSwitch = /*@__PURE__*/ createReactComponent('sdf-switch');
export const SdfTab = /*@__PURE__*/ createReactComponent('sdf-tab');
export const SdfTabGroup = /*@__PURE__*/ createReactComponent('sdf-tab-group');
export const SdfTable = /*@__PURE__*/ createReactComponent('sdf-table');
export const SdfTag = /*@__PURE__*/ createReactComponent('sdf-tag');
export const SdfTextEditor = /*@__PURE__*/ createReactComponent('sdf-text-editor');
export const SdfTextarea = /*@__PURE__*/ createReactComponent('sdf-textarea');
export const SdfTimePicker = /*@__PURE__*/ createReactComponent('sdf-time-picker');
export const SdfTimePickerV2 = /*@__PURE__*/ createReactComponent('sdf-time-picker-v2');
export const SdfTimeSpinner = /*@__PURE__*/ createReactComponent('sdf-time-spinner');
export const SdfTimeline = /*@__PURE__*/ createReactComponent('sdf-timeline');
export const SdfTimelineEvent = /*@__PURE__*/ createReactComponent('sdf-timeline-event');
export const SdfToggle = /*@__PURE__*/ createReactComponent('sdf-toggle');
export const SdfTooltip = /*@__PURE__*/ createReactComponent('sdf-tooltip');
export const SdfViewStack = /*@__PURE__*/ createReactComponent('sdf-view-stack');
export const SdfWizardLayout = /*@__PURE__*/ createReactComponent('sdf-wizard-layout');
export const SdfWizardStepsVertical = /*@__PURE__*/ createReactComponent('sdf-wizard-steps-vertical');
export const SdfWizardStepsVerticalItem = /*@__PURE__*/ createReactComponent('sdf-wizard-steps-vertical-item');
//# sourceMappingURL=components.js.map


// WEBPACK FOOTER //
// ./~/@waypoint/react-components/dist/components.js